<template>
    <div class="mt-5">
        <div ref="real_estate_wrapper" class="real_estate_wrapper position-relative overflow-hidden">
            <BContainer>
                <BRow v-for="(provider, i) in providers"
                    class="no-gutters d-flex py-4 justify-content-between align-items-center mt-5 mb-5"
                        :ref="`case_index_${provider.index}`"
                        :data-index="provider.index"
                        :data-thumbnail="provider.url"
                        :id="provider.url"
                        :key="provider.url">

                    <BCol md="6" sm="12" :class="provider.url" class="accordion item-gallery-effect"
                            role="tablist">
                        <div class="card-image position-relative" v-b-modal="`modal_${provider.index}`">
                            <img class="__case-pic" width="100%" :src="getPicture(provider.index)"/>
                        </div>
                    </BCol>
                    <BCol md="5" sm="12"
                            class="accordion p-3 item-gallery-effect "
                            role="tablist">
                        <h3 v-if="provider.founding_office"
                            class="text-primary font-weight-900 fs-xl-34px fs-lg-26px fs-20px">
                            {{ provider.founding_office }}
                        </h3>
                        <h2 v-if="provider.name" v-b-modal="`modal_${provider.index}`"
                            class="case_title font-weight-900 fs-xl-60px fs-lg-40px fs-md-34px fs-24px text-capitalize">
                            {{provider.name }}</h2>
                        <h5 v-if="provider.nro_files" class="fs-xl-24px fs-md-20px fs-18px">
                            <strong>{{ $t('appContent.nro_leaks') }}:&nbsp;</strong>
                            <span class="font-weight-light">{{provider.nro_files }}</span>
                        </h5>
                        <h5 v-if="provider.time_period" class="fs-xl-24px fs-md-20px fs-18px">
                            <strong>{{ $t('appContent.time_period') }}:&nbsp;</strong>
                            <span class="font-weight-light">{{provider.time_period }}</span>
                        </h5>
                        <div class="w-100 mt-3"
                            :class="[index == i  ? 'visible-annimation' : 'invisible-annimation'] ">
                            <span class="btn-read-more font-weight-900" v-b-modal="`modal_${provider.index}`"> {{ $t('modal.btn_read') }}</span>
                        </div>
                    </BCol>
                    <Modal :provider="provider"/>
                </BRow>

            </BContainer>

        </div>

        <div @click="next" class="btn-next noselect arrow-down-float d-md-none d-block">
            <img :class="reverse ? 'arrowBack' : 'arrow'" :src="require('@/assets/img/arrow-circle.svg')">
        </div>

        <div class="side-navigation">

            <div class="progress-bar">
                <div ref="progres-bar-nav" class="progress-div" id="progressDiv">
                </div>
            </div>
            <div @click="next" class="d-none d-sm-none d-md-block btn-next noselect">
                <img :class="reverse ? 'arrowBack' : 'arrow'" :src="require('@/assets/img/right.svg')">
            </div>
        </div>

        <IframModal/>
        <AppAbout />
    </div>
</template>


<script>
    import utils from '@/mixins/utils'
    import * as d3 from 'd3'
    import {kebabCase} from 'lodash'
    import Modal from '@/components/Modal.vue'
    import IframModal from '@/components/IframModal.vue'
    import AppAbout from '@/components/AppAbout';

    // import store from "../store";
    export default {
        name: 'Home',
        data() {
            return {
                wheeling: false,
                scrollTimeout: null,
                index: 0,
                reverse: false,
                viewIndex: 0,
                hasHeader: false,
                viewLimit: 0,
                isAnimating: false,
                isMobile:false,
                cid: null
            }
        },
        mixins: [utils],
        components: {
            Modal,
            IframModal,
            AppAbout
        },
        props: {
            content: {
                type: Object,
                default: null,
            },
        },
        computed: {
            providers() {
                return this.$store.state.providers.all
            },
            slidesLength() {
                return this.$el.querySelector('.carousel').childElementCount
            },
            slideHeight() {
                return this.$el.querySelector('#CarouselSlide').offsetHeight
            },
            slidesHeight() {
                return false //this.$el.querySelector('.carousel').offsetHeight
            }
        },
        watch: {
            index: function (val) {
                this.reverse = (val == this.slidesLength - 1)
            },
        },

        methods: {
            kebabCase,
            next() {
                window.scrollTo({top: (window.scrollY + 100), left: 0});
            },
            progressBar() {
                if(this.$refs['real_estate_wrapper']) {
                    let scale = d3.scaleLinear().domain([0, this.$refs['real_estate_wrapper'].offsetHeight]).range([0, window.innerHeight*.75])

                    this.$refs['progres-bar-nav'].style.height = `${scale(window.scrollY)}px`
                }
            },
            slide(top, dir = "+") {
                let goto = this.slideHeight / 2;
                if (top) {
                    let index = (dir == '+') ? 1 : -1;
                    this.progressBar(dir)
                    this.index += index;
                    goto = top + (this.slideHeight * -index);
                } else {
                    this.index = 0
                    this.$el.querySelector('#progressDiv').style.top = '0';
                }
                this.$el.querySelector('.carousel').style.top = `${goto}px`
            },
            swipe(dir = "+") {
                if (this.isAnimating || document.querySelector('.modal-body') !== null) return;
                this.isAnimating = true;

                let top = (!isNaN(parseInt(this.$el.querySelector('.carousel').style.top))) ? parseInt(this.$el.querySelector('.carousel').style.top) : 0;
                let cooldown = false;
                if (dir === "-") {
                    if ((this.viewIndex == 1) && this.index == 0) {
                        document.getElementById('app').scrollTo({top: 0, left: 0, behavior: 'smooth'});
                        if (this.hasHeader) {
                            this.viewIndex--;
                        }
                    } else if (this.viewIndex == 1) {
                        this.slide(top, '-');
                        cooldown = true;
                        if (window.scrollY != this.$el.offsetTop) {
                            document.getElementById('app').scrollTo({top: this.$el.offsetTop, left: 0});
                        }
                        window.scrollTo(0,document.body.scrollHeight /2)
                    } else if (this.viewIndex == 2) {
                        document.getElementById('app').scrollTo({top: this.$el.offsetTop, left: 0, behavior: 'smooth'});
                        this.viewIndex--;
                    }
                } else {
                    
                    if ((this.viewIndex == 1) && (this.index + 1) == this.slidesLength) {
                        document.getElementById('app').scrollTo({top: this.viewLimit, left: 0, behavior: 'smooth'});
                        this.viewIndex++;
                    } else if ((this.viewIndex == 1) && this.$el.querySelector('.carousel').offsetHeight > Math.abs(top) + 2 * this.slideHeight) {
                        this.slide(top);
                        cooldown = true;
                        if (window.scrollY != this.$el.offsetTop) {
                            document.getElementById('app').scrollTo({top: this.$el.offsetTop, left: 0});
                        }
                        window.scrollTo(0,document.body.scrollHeight /2)
                    } else if (this.viewIndex == 0) {
                        document.getElementById('app').scrollTo({top: this.$el.offsetTop, left: 0, behavior: 'smooth'});
                        this.viewIndex++;
                        window.scrollTo(0,document.body.scrollHeight /2)
                    }
                }
                clearTimeout(this.cid);
                this.cid = setTimeout(function (){
                    this.isAnimating = false;
                }.bind(this),cooldown ? 500 : 0);
            },
            desktopExperienceHandler() {
                window.addEventListener("scroll", () => {
                    this.progressBar()
                });
            },
            mobileExperienceHandler() {
                this.$el.querySelector('.side-navigation').style.display = `none`;
                var yDown = null;
                var that = this;
                const getTouches = (e) => e.touches || e.originalEvent.touches || e.targetTouches || e.changedTouches;
                // document.getElementById('app').addEventListener('touchstart',touchstart, false);
                // document.getElementById('app').addEventListener('touchmove', touchmove, false);
                window.addEventListener('touchstart',touchstart, false);
                window.addEventListener('touchmove', touchmove, false);
                function touchstart(e){
                    const firstTouch = getTouches(e)[0];
                    yDown = firstTouch.clientY;
                }
                function touchmove(e){
                    if (!yDown) return;
                    var yUp = e.touches[0].clientY;
                    var yDiff = yDown - yUp;
                    that.swipe((yDiff > 0) ? "+" : "-");
                    yDown = null;
                }
            },
            fakeScroll(){
                let header = document.querySelector('#main-header');
                let footer = document.querySelector('.app_gallery_footer');
                let h = this.slidesHeight + (header ? header.offsetHeight : 0) + (footer ? footer.offsetHeight : 0);
                h = h - window.innerHeight;
                document.body.style.height = `${h}px`
            }
        },
        mounted() {
            this.hasHeader = document.querySelector("#main-header") !== null;
            this.viewIndex = this.hasHeader ? 0 : 1;
            this.viewLimit = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
            
            if(this.$route.query && this.$route.query.broker && document.querySelector(`#${this.$route.query.broker}`)) {
                let pos = document.querySelector(`#${this.$route.query.broker}`)
                
                setTimeout(() => {
                    pos.scrollIntoView({behavior: "smooth", block: "center"})
                }, 100)
            }
            
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            if (window.innerWidth >= window.innerHeight && window.innerWidth >= 720) {
                this.desktopExperienceHandler();
            } else {
                this.isMobile = true;
                document.querySelector('.carousel').style.transform = `translateY(-${document.querySelector('#CarouselSlide').offsetHeight / 2}px`
                this.mobileExperienceHandler();
            }
            this.fakeScroll();
            // setTimeout(function () {
            //     document.querySelector('.carousel').style.top = document.querySelector('#CarouselSlide').offsetHeight / 2 + 'px';
            // }, 100);

        }
    }

</script>


<style lang="scss">
    #app{
        position: relative;
        width: 100%;
        min-height: 100vh;
        scroll-behavior: smooth;
    }
    body {

        &::-webkit-scrollbar,&::-webkit-scrollbar-track,&::-webkit-scrollbar-thumb {
            width: 0px;
        }
    }

    @media (min-width: 1465px) {
        .container, .container-sm, .container-md, .container-lg, .container-xl {
            max-width: 1400px;
        }
    }

    .noselect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .arrowBack {
        transform: rotate(180deg);
    }

    body.disable-scroll {
        overflow: hidden;

    }

    .arrow-down-float {
        position: absolute;
        z-index: 9999;
        bottom: 75px;
        right: 5%;
        cursor: pointer;
    }

    .case_title {
        &:after {
            content: '';
            width: 5rem;
            height: 1px;
            background-color: var(--app-color-red);
            display: block;
            margin: 1rem 0;
        }
    }
    .btn-read-more{
        background-color: var(--app-color-red);
        color: white;
        padding: .3rem 1.5rem;
        transition: opacity 300ms;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: fit-content;
        &:hover,&:focus{
            opacity: .9;
        }
    }

    .card-image {
        cursor: url(~@/assets/img/plus.svg), auto;;
        &:focus {
            outline: none;
        }
        .__case-pic {
            width: 100%;
            height: 40vh;
            object-fit: cover;
            object-position: center;
        }
        @media (max-width: 720px) {
            .__case-pic {
                height: 27vh;
            }
        }
    }

    .scroll-down .sticky-navigation {
        transform: translate3d(0, -100%, 0);
        transition: .5s;

    }

    .scroll-up .sticky-navigation {
        transform: none;
        transition: .5s;
    }

    .visible-annimation {
        visibility: visible;
        animation: floatBottom 1s ease-in-out;
    }

    .invisible-annimation {
        visibility: hidden;
        @media (max-width: 720px) {
            visibility: visible;
        }
    }

    @keyframes floatBottom {
        from {
            transform: translateY(3rem);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @keyframes floatTop {
        from {
            transform: translateY(0rem);
            opacity: 1;
        }
        to {
            transform: translateY(3rem);
            opacity: 0;
        }
    }

    .covid-icon {
        top: 0;
        left: 0;
        img {
            width: 10rem;
            height: auto;
        }
    }

    .plus-icon {
        position: absolute;
        top: 10%;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        img {
            width: 3rem;
            height: auto;
        }

    }

    .real_estate_wrapper {
        scroll-behavior: smooth;
        min-height: 100vh;
    }

    .overflow-y-auto {
        overflow-y: auto !important;
    }

    .flex-1 {
        flex: 1 !important;
    }

    .app_title {
        color: #000;
    }

    .app_description {
        color: #000;
    }

    .item-summary {
        font-size: 21px;
        color: #000;
    }

    .card {
        background-color: #fff;
    }

    h4 {
        font-size: 18px;
        color: var(--app-color-black);
    }

    .case-hide {
        background: var(--app-color-light);
    }

    .side-navigation {
        position: fixed;
        position: -webkit-sticky;
        left: 93%;
        top: 0;
        bottom: 0;
        height: 85vh;
        width: fit-content;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;
        .progress-bar {
            height: 80%;
            width: .3rem;
            position: relative;
            background-color: #ededed;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 1rem;
            .progress-div {
                position: absolute;
                width: .3rem;
                height: 0;
                background-color: var(--app-color-red);
                top: 0;
                transition: height .3s ease-in-out;
            }
        }
        .btn-next {
            border: 1px solid var(--app-color-red);
            padding: 1.5rem .5rem;
            &:hover {
                cursor: pointer;
            }
            &:focus {
                outline: none;
            }
        }
    }

    .--btn-modal {
        border: none;
        background-color: unset;
        color: var(--app-color-red);
        text-decoration-line: underline;
        font-weight: bold;
        &:focus {
            outline: none;
        }
    }

    .text-end {
        text-align: end !important;
    }

    .iframe-modal {
        position: absolute;
        top: 4%;
        right: 7%;
        &:focus {
            outline: none;
        }
        .--btn-modal-iframe {
            color: #7A7A7A;
        }
    }
</style>
